import http from "../http-common";

class TableauService {
    getCreateToken() {
        return http.get("/tableau/token");
    }

    tableauAccessKey(access_key) {
        return http.get("/tableau/access/"+ access_key);
    }

    setTableauInfo(tableauResponse) {
        localStorage.setItem('tableau_access_token', tableauResponse.access_token);
        localStorage.setItem('tableau_refresh_token', tableauResponse.refresh_token);
    }

    getTableauAccessoken() {
        return localStorage.getItem('tableau_access_token');
    }

    getTableauRefreshToken() {
        return localStorage.getItem('tableau_refresh_token');
    }
    logout() {
        localStorage.removeItem('tableau_access_token');
        localStorage.removeItem('tableau_refresh_token');
    }
}

export default new TableauService();